import { EmailTemplatesServiceClient } from '@pushwoosh/rpc-service-client/pushwoosh/email_templates/Email_templatesServiceClientPb';
import {
  EmailContent,
  ListEmailTemplatesRequest,
  GetEmailTemplateRequest,
  CreateEmailTemplateRequest,
  UpdateEmailTemplateRequest,
  DeleteEmailTemplateRequest,
  GetEmailTemplateLabelsRequest,
} from '@pushwoosh/rpc-service-client/pushwoosh/email_templates/email_templates_pb';

export type EmailTemplatesExportClasses = {
  EmailTemplatesServiceClient: typeof EmailTemplatesServiceClient;
  EmailContent: typeof EmailContent;
  ListEmailTemplatesRequest: typeof ListEmailTemplatesRequest;
  GetEmailTemplateRequest: typeof GetEmailTemplateRequest;
  CreateEmailTemplateRequest: typeof CreateEmailTemplateRequest;
  UpdateEmailTemplateRequest: typeof UpdateEmailTemplateRequest;
  DeleteEmailTemplateRequest: typeof DeleteEmailTemplateRequest;
  GetEmailTemplateLabelsRequest: typeof GetEmailTemplateLabelsRequest;
};

export const emailTemplates: EmailTemplatesExportClasses = {
  EmailTemplatesServiceClient,
  EmailContent,
  ListEmailTemplatesRequest,
  GetEmailTemplateRequest,
  CreateEmailTemplateRequest,
  UpdateEmailTemplateRequest,
  DeleteEmailTemplateRequest,
  GetEmailTemplateLabelsRequest,
};
